import React, { useState } from 'react';
import { Protect } from '@clerk/clerk-react';
import { DropdownItem, DropdownMenu, Loader } from '@nearst/ui';
import { exportInventory, useInventory } from '@services/stock';
import { useShop } from '@services/ShopProvider';
import { download } from '@utils/download';

import styles from './InventoryActions.module.scss';

const InventoryActions = ({ setBulkHideModal, setBulkUnhideModal, setBulkUploadModalOpen, setQuantityBufferModal, disabled }) => {
	const { shop, organisation } = useShop();
	const { filters } = useInventory(organisation.id, shop.id);
	const [isExporting, setIsExporting] = useState(false);

	const handleExport = async () => {
		setIsExporting(true);
		try {
			const queryParams = {
				filters
			};

			const result = await exportInventory(shop?.id, queryParams);

			if (result?.url) {
				download(result.filename, result.url, true);
			}
		} finally {
			setIsExporting(false);
		}
	};

	return (
		<div className={styles.container}>
			{isExporting && (
				<p className={styles.exporting}>
					Starting export
					<Loader size={16} />
				</p>
			)}
			<Protect
				condition={(has) =>
					has({ permission: 'org:inventory:hide' }) ||
					has({ permission: 'org:inventory:upload' }) ||
					has({ permission: 'org:inventory:read' }) ||
					has({ permission: 'org:locations:manage' })
				}
			>
				<DropdownMenu primary={false} disabled={disabled} secondary={true} buttonText={'Actions'}>
					<Protect permission="org:inventory:read">
						<DropdownItem onClick={handleExport} disabled={isExporting}>
							Export to CSV
						</DropdownItem>
					</Protect>
					<Protect permission="org:inventory:hide">
						<DropdownItem onClick={() => setBulkHideModal(true)}>Hide products</DropdownItem>
						<DropdownItem onClick={() => setBulkUnhideModal(true)}>Unhide products</DropdownItem>
					</Protect>
					<Protect permission="org:inventory:upload">
						<DropdownItem onClick={() => setBulkUploadModalOpen(true)}>Upload product data</DropdownItem>
					</Protect>
					<Protect permission="org:locations:manage">
						<DropdownItem onClick={() => setQuantityBufferModal(true)}>Set quantity buffer</DropdownItem>
					</Protect>
				</DropdownMenu>
			</Protect>
		</div>
	);
};

export default InventoryActions;
